module.exports = __webpack_public_path__ + "img/computer2.8b65e65c.gif";